var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 211,
    viewBox: "0 0 212 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M318.325 104.569C376.868 46.0257 376.868 -48.8912 318.325 -107.434C259.782 -165.977 164.866 -165.977 106.323 -107.434C47.7797 -48.8912 47.7797 46.0257 106.323 104.569C164.866 163.112 259.782 163.112 318.325 104.569Z",
    stroke: "white",
    strokeWidth: 1.0531,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 142.74C291.958 142.74 356.51 78.1884 356.51 -1.44C356.51 -81.0684 291.958 -145.62 212.33 -145.62C132.701 -145.62 68.1499 -81.0684 68.1499 -1.44C68.1499 78.1884 132.701 142.74 212.33 142.74Z",
    stroke: "white",
    strokeWidth: 1.1458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M310.229 96.4723C364.301 42.4008 364.301 -45.2664 310.229 -99.3379C256.158 -153.409 168.49 -153.409 114.419 -99.3378C60.3475 -45.2664 60.3475 42.4008 114.419 96.4723C168.49 150.544 256.158 150.544 310.229 96.4723Z",
    stroke: "white",
    strokeWidth: 1.2385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 131.29C285.635 131.29 345.06 71.8648 345.06 -1.44C345.06 -74.7448 285.635 -134.17 212.33 -134.17C139.025 -134.17 79.5999 -74.7448 79.5999 -1.44C79.5999 71.8648 139.025 131.29 212.33 131.29Z",
    stroke: "white",
    strokeWidth: 1.3312,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 125.57C282.476 125.57 339.34 68.7057 339.34 -1.44C339.34 -71.5857 282.476 -128.45 212.33 -128.45C142.184 -128.45 85.3198 -71.5857 85.3198 -1.44C85.3198 68.7057 142.184 125.57 212.33 125.57Z",
    stroke: "white",
    strokeWidth: 1.4239,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 119.84C279.311 119.84 333.61 65.5411 333.61 -1.44C333.61 -68.4211 279.311 -122.72 212.33 -122.72C145.349 -122.72 91.0498 -68.4211 91.0498 -1.44C91.0498 65.5411 145.349 119.84 212.33 119.84Z",
    stroke: "white",
    strokeWidth: 1.5166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 114.11C276.146 114.11 327.88 62.3765 327.88 -1.43999C327.88 -65.2565 276.146 -116.99 212.33 -116.99C148.513 -116.99 96.7798 -65.2565 96.7798 -1.43999C96.7798 62.3765 148.513 114.11 212.33 114.11Z",
    stroke: "white",
    strokeWidth: 1.6093,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 108.39C272.987 108.39 322.16 59.2174 322.16 -1.43999C322.16 -62.0974 272.987 -111.27 212.33 -111.27C151.673 -111.27 102.5 -62.0974 102.5 -1.43999C102.5 59.2174 151.673 108.39 212.33 108.39Z",
    stroke: "white",
    strokeWidth: 1.702,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 102.66C269.823 102.66 316.43 56.0528 316.43 -1.43999C316.43 -58.9328 269.823 -105.54 212.33 -105.54C154.837 -105.54 108.23 -58.9328 108.23 -1.43999C108.23 56.0528 154.837 102.66 212.33 102.66Z",
    stroke: "white",
    strokeWidth: 1.7948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 96.94C266.664 96.94 310.71 52.8938 310.71 -1.43999C310.71 -55.7738 266.664 -99.82 212.33 -99.82C157.996 -99.82 113.95 -55.7738 113.95 -1.43999C113.95 52.8938 157.996 96.94 212.33 96.94Z",
    stroke: "white",
    strokeWidth: 1.8875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 91.21C263.499 91.21 304.98 49.7292 304.98 -1.44C304.98 -52.6092 263.499 -94.09 212.33 -94.09C161.161 -94.09 119.68 -52.6092 119.68 -1.44C119.68 49.7292 161.161 91.21 212.33 91.21Z",
    stroke: "white",
    strokeWidth: 1.9802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 85.48C260.335 85.48 299.25 46.5646 299.25 -1.44C299.25 -49.4446 260.335 -88.36 212.33 -88.36C164.325 -88.36 125.41 -49.4446 125.41 -1.44C125.41 46.5646 164.325 85.48 212.33 85.48Z",
    stroke: "white",
    strokeWidth: 2.0729,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M215.247 79.7614C260.066 78.1649 295.104 40.538 293.508 -4.28061C291.911 -49.0992 254.284 -84.1377 209.466 -82.5412C164.647 -80.9447 129.609 -43.3178 131.205 1.50083C132.802 46.3194 170.429 81.3579 215.247 79.7614Z",
    stroke: "white",
    strokeWidth: 2.1656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 74.03C254.011 74.03 287.8 40.2409 287.8 -1.44C287.8 -43.1209 254.011 -76.91 212.33 -76.91C170.649 -76.91 136.86 -43.1209 136.86 -1.44C136.86 40.2409 170.649 74.03 212.33 74.03Z",
    stroke: "white",
    strokeWidth: 2.2583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M214.84 68.3183C253.338 66.9469 283.436 34.6258 282.065 -3.87298C280.693 -42.3717 248.372 -72.4694 209.873 -71.098C171.375 -69.7267 141.277 -37.4055 142.648 1.09322C144.02 39.592 176.341 69.6897 214.84 68.3183Z",
    stroke: "white",
    strokeWidth: 2.351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 62.58C247.687 62.58 276.35 33.9173 276.35 -1.43999C276.35 -36.7973 247.687 -65.46 212.33 -65.46C176.973 -65.46 148.31 -36.7973 148.31 -1.43999C148.31 33.9173 176.973 62.58 212.33 62.58Z",
    stroke: "white",
    strokeWidth: 2.4437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M214.432 56.8652C246.605 55.7191 271.758 28.7084 270.612 -3.465C269.466 -35.6384 242.455 -60.791 210.281 -59.6449C178.108 -58.4988 152.955 -31.4881 154.101 0.68525C155.248 32.8586 182.258 58.0112 214.432 56.8652Z",
    stroke: "white",
    strokeWidth: 2.5364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 51.13C241.363 51.13 264.9 27.5936 264.9 -1.43999C264.9 -30.4736 241.363 -54.01 212.33 -54.01C183.296 -54.01 159.76 -30.4736 159.76 -1.43999C159.76 27.5936 183.296 51.13 212.33 51.13Z",
    stroke: "white",
    strokeWidth: 2.6292,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M214.024 45.422C239.878 44.5011 260.089 22.7961 259.168 -3.05739C258.248 -28.9109 236.543 -49.1227 210.689 -48.2018C184.836 -47.2808 164.624 -25.5759 165.545 0.277622C166.466 26.1311 188.171 46.3429 214.024 45.422Z",
    stroke: "white",
    strokeWidth: 2.7219,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 39.68C235.04 39.68 253.45 21.2699 253.45 -1.44C253.45 -24.15 235.04 -42.56 212.33 -42.56C189.62 -42.56 171.21 -24.15 171.21 -1.44C171.21 21.2699 189.62 39.68 212.33 39.68Z",
    stroke: "white",
    strokeWidth: 2.8146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M213.616 33.9789C233.15 33.2831 248.421 16.8838 247.725 -2.64978C247.029 -22.1834 230.63 -37.4545 211.097 -36.7587C191.563 -36.0628 176.292 -19.6636 176.988 -0.130013C177.683 19.4036 194.083 34.6747 213.616 33.9789Z",
    stroke: "white",
    strokeWidth: 2.9073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M212.33 28.22C228.711 28.22 241.99 14.9408 241.99 -1.44C241.99 -17.8208 228.711 -31.1 212.33 -31.1C195.949 -31.1 182.67 -17.8208 182.67 -1.44C182.67 14.9408 195.949 28.22 212.33 28.22Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroVector);
export default __webpack_public_path__ + "static/media/hero-vector.5110c9ca33482b417d69547dcdbd9b40.svg";
export { ForwardRef as ReactComponent };